module.exports = __webpack_public_path__ + "img/yry.c960dbc9.png";